import * as React from 'react';
import { translate } from 'react-i18next';
import { observer } from 'mobx-react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ElectroSwitch from 'forms/components/inputs/ElectroSwitch';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

import type { TranslatorProps } from 'react-i18next';

import styles from './UserNotificationSelection.module.scss';
import { FormHelperText } from '@material-ui/core';

type Props = {
  field: Object,
};

type InjectedProps = TranslatorProps;

@translate()
export default class UserNotificationSelection extends ComponentWithInjectedProps<
  Props,
  InjectedProps,
  {}
> {
  @observer
  renderNotificationThresholds(item) {
    const field = item.$('thresholds');

    return (
      <React.Fragment>
        <h4>{field.label}</h4>
        <FormHelperText className={styles.helperText}>{field.extra.helperText}</FormHelperText>
        {field.map((item, index) => (
          <div key={index}>
            <FormControlLabel
              label={item.label}
              control={<Checkbox checked={item.value} onClick={() => item.set(!item.value)} />}
            />
          </div>
        ))}
      </React.Fragment>
    );
  }

  @observer
  renderNotificationSection(item: Object, index: Number) {
    const isAppNotificationOnly = item.extra && item.extra.app_notifications_only;
    const isHidden = item.extra && item.extra.hidden;
    const isContractOrAssetCalDue =
      item.name === 'ContractDue' || item.name === 'AssetCalibrationDue';

    return (
      <div className={styles['notificationSection']} key={index}>
        <h4>{item.label}</h4>
        {!isAppNotificationOnly && (
          <React.Fragment>
            {!isHidden && (
              <ElectroSwitch
                field={item.$('email')}
                onChange={() => {
                  if (item.$('email').value) {
                    item.$('emailOnlyMe').set(false);
                    item.$('app').set(false);
                  }
                  this.checkThresholds(item);
                }}
              />
            )}
            {isContractOrAssetCalDue && (
              <ElectroSwitch
                field={item.$('emailOnlyMe')}
                onChange={() => {
                  if (item.$('emailOnlyMe').value) {
                    item.$('email').set(false);
                    item.$('app').set(false);
                  }
                  this.checkThresholds(item);
                }}
              />
            )}
          </React.Fragment>
        )}
        <ElectroSwitch
          field={item.$('app')}
          onChange={() => {
            if (item.$('app').value) {
              item.$('email').set(false);
              item.$('emailOnlyMe').set(false);
            }
            this.checkThresholds(item);
          }}
        />
        {(item.$('email').value || item.$('emailOnlyMe').value || item.$('app').value) && (
          <div className={styles.threshold}>{this.renderNotificationThresholds(item)}</div>
        )}
      </div>
    );
  }

  checkThresholds(item) {
    const email = item.$('email');
    const emailOnlyMe = item.$('emailOnlyMe');
    const app = item.$('app');
    const thresholds = item.$('thresholds');

    if (!email.value && !emailOnlyMe.value && !app.value) {
      thresholds.map(item => item.set(false));
    }
  }

  render() {
    const { field } = this.props;

    return (
      <React.Fragment>
        <div className={styles.notificationSelectionContainer}>
          {field.map((item, index) => {
            return this.renderNotificationSection(item, index);
          })}
        </div>
      </React.Fragment>
    );
  }
}
